export const YEAR_TIME_VALUE = 60 * 60 * 24 * 365;
export const MONTH_TIME_VALUE = 60 * 60 * 24 * 30;
export const DAY_TIME_VALUE = 60 * 60 * 24;
export const HOUR_TIME_VALUE = 60 * 60;
export const MINUTE_TIME_VALUE = 60;
export const SECOND_TIME_VALUE = 1;
